<template>    
  <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;" >
    <v-flex xs6 class="inline-block px-4">      
      <v-text-field hide-details  :label="$t('Admin.PositionRemarquable.Form.Libelle')" v-model="prmLibelle" />            
      <v-select hide-details  
        :items="enseignes"
        item-text="ENS_LIBELLE"
        item-value="ENS_ID"
        :label="$t('Admin.PositionRemarquable.Form.Company')"
        v-model="ensId"
      ></v-select>      
      <!-- <v-text-field hide-details  :label="$t('Admin.PositionRemarquable.Form.Lat')" v-model.number="gpsLat" />                  
      <v-text-field hide-details  :label="$t('Admin.PositionRemarquable.Form.Lng')" v-model.number="gpsLon" />         -->
      <v-layout row>
        <lat-lng-field :format="coordFormatFilter" :label="$t('Admin.PositionRemarquable.Form.Lat')" v-model.number="gpsLat" :isLat="true" class="mr-4" />        
        <lat-lng-field :format="coordFormatFilter" :label="$t('Admin.PositionRemarquable.Form.Lng')" v-model.number="gpsLon" :isLat="false" class="ml-4" />  
      </v-layout>      
    </v-flex>                          
    <v-flex  xs6 class="pa-2 fillContent" style="position:relative;overflow:hidden;">          
      <vl-map ref="map"                                     
          :load-tiles-while-animating="true" 
          :load-tiles-while-interacting="true"
          data-projection="EPSG:4326" 
          class="fillContent"            
          @pointermove="onPointerMove" 
          @singleclick="onSingleclick" 
          @mounted="onMapMounted">
          <vl-view ref="view" :zoom.sync="zoom" ></vl-view>                  
          <vl-layer-tile :zIndex="1">
            <vl-source-osm ></vl-source-osm> 
          </vl-layer-tile>
          <vl-layer-vector ref="vectorsLayer" :zIndex="100" >                    
          <vl-source-vector>          
            <!-- Way Point on Map -->  
            <vl-feature v-for="wpt in positionRemarquables.filter(w => w.id != modified.id)" :properties="{type:hoverWptId==wpt.id?'hoverWayPoint':'wayPoint',wpt_id:wpt.id}" :key="'WP' + wpt.id">
              <template slot-scope="feature">
                <vl-geom-point :coordinates="[wpt.gpsLon,wpt.gpsLat]"></vl-geom-point>                
              </template>
            </vl-feature>                        
          </vl-source-vector>
          <vl-style-func :factory="mapStylesFunction" />
        </vl-layer-vector>
          <vl-layer-vector :zIndex="101">
        <!-- Way Point on Map -->
            <vl-source-vector ref="wayPointIdent" ident="wayPointIdent" >
              <vl-feature :properties="{type:'modifyWayPoint',wpt_id:modified.id}">
                <template slot-scope="feature">
                  <vl-geom-point ref="modWaypoint" :coordinates="[gpsLon,gpsLat]"></vl-geom-point>                
                </template>
              </vl-feature>
            </vl-source-vector>                        
          </vl-layer-vector>                                        
          <vl-interaction-modify @modifyend="onModifyend" source="wayPointIdent"></vl-interaction-modify>                
        </vl-map>
        <v-toolbar style="position:absolute;bottom:20px;right:0px;width:90%">          
          <v-toolbar-title>      
            {{toCoordString()}}
          </v-toolbar-title>       
        </v-toolbar>   
    </v-flex>
  </v-layout>  
</template>

<script lang="ts">
import Vue from 'vue'
import { Watch} from 'vue-property-decorator'
import * as mapStyles from '@/components/map/MapStyles'
import Component from 'vue-class-component'

@Component({
  name: 'AdminPositionRemarquableForm'  
})
export default class AdminPositionRemarquableForm extends Vue {  

    
  zoom = 4

   //Global waypoints array  
  get positionRemarquables(){
    return this.$store.myGetters.positionRemarquables
  }

  created(){
    this.$store.myActions.ENSEIGNE_ENSURE_LIST()
  }

  mapStylesFunction() { 
    return (feature:any) => {                                
        return mapStyles.black(feature)
    }
  }

  mounted(){
    setTimeout(() => this.bestFit(),400)
    setTimeout(() => this.updateSize(),1100)
  }

  bestFit(){
    this.goTo([this.gpsLon,this.gpsLat],4)
  }

  get coordFormatFilter(){
    return this.$store.myGetters.coordFormatFilter 
  }

  toCoordString(){
    //@ts-ignore    
    return this.$options.filters[this.coordFormatFilter]([this.gpsLon,this.gpsLat])
  }

  get enseignes() {
    return this.$store.myGetters.enseignes
  }

  //@ts-ignore
  goTo(location,bestzoom=0,duration = 700) {       
    //@ts-ignore 
    let zoom = this.$refs.view.$view.getZoom()
    let parts = 2
    let called = false        
    //@ts-ignore
    function callback(complete) {
      --parts;
      if (called) {            
        return
      }
      if (parts === 0 || !complete) {
        called = true
      }
    }
    //@ts-ignore
    this.$refs.view.animate({
      center: location,
      duration: duration
    }, callback)
    if(bestzoom > 0){
    //@ts-ignore
    this.$refs.view.animate({
        zoom: bestzoom,
        duration: duration / 2
      }, callback)
    }
  }

  get modified(){
    return this.$store.myGetters.modifiedAdmPositionRemarquable
  }
  

  get prmLibelle(){
    return this.modified.prmLibelle!
  }
  set prmLibelle(value:string){    
    this.$store.myActions.POSITIONREMARQUABLE_UPDATE_MODIFIED_ADM({
      prmLibelle:value
    })
  }

  get gpsLat(){
    return this.modified.gpsLat!
  }
  set gpsLat(value:number){    
    this.$store.myActions.POSITIONREMARQUABLE_UPDATE_MODIFIED_ADM({
      gpsLat:value
    })
  }

  get gpsLon(){
    return this.modified.gpsLon!
  }
  set gpsLon(value:number){    
    this.$store.myActions.POSITIONREMARQUABLE_UPDATE_MODIFIED_ADM({
      gpsLon:value
    })
  }

  get ensId() {
    return this.modified.ensId!
  }
  set ensId(value: number) {      
    this.$store.myActions.POSITIONREMARQUABLE_UPDATE_MODIFIED_ADM({
      ensId: value
    })
  }

  @Watch('modified')
  onModifiedChanged(newValue: any, oldValue: any) {        
    if(this.$refs.map) this.bestFit()
  }

  onModifyend(evt:any) {  
      //@ts-ignore    
      const newWayPt = this.$refs.modWaypoint.getCoordinates()
      this.gpsLon = newWayPt[0]
      this.gpsLat = newWayPt[1]      
  }

  onMapMounted(){

  }

  hoverWptId = -1

  onPointerMove ({ pixel }:{pixel:any}) {       
    if(this.$refs.map) {
      let find = false      
      //@ts-ignore
      this.$refs.map.forEachFeatureAtPixel(pixel, (feature, layer) => {                 
        if(!find) {          
          find = true
          const type = feature.get('type')          
          if(type == 'wayPoint' || type == 'hoverWayPoint') {
            this.hoverWptId = feature.get('wpt_id')            
          }          
        }
      }, {
        hitTolerance: 5
      })
      if(!find) {        
        this.hoverWptId = -1     
      }
    }
  }
  
  //@ts-ignore  
  onSingleclick({pixel}) {                
    if(this.$refs.map) {     
      let  find = false   
      //@ts-ignore  
      let feature = this.$refs.map.forEachFeatureAtPixel(pixel, (feature, layer) => {
        if(!find) {              
          const type = feature.get('type')
          if(type == 'hoverWayPoint') {
            find = true                
            //this.$store.myActions.POSITIONREMARQUABLE_SELECT_DETAIL(this.hoverWptId)
            //@ts-ignore  
            this.$router.push({name:`EditPositionRemarquable`,params:{itemid:this.hoverWptId}})
          }          
        }
      })        
    }
  }


  updateSize() {        
    if(!this.$refs.map) this.$nextTick(this.updateSize)
    else  setTimeout(()=> {
      if(this.$refs.map) {
        //@ts-ignore
        this.$refs.map.updateSize()
        this.redrawMap()   
      }       
    },200)        
  }
  redrawMap() {
    //Twick force le refresh de la carte
    this.zoom +=1
    this.zoom -=1          
  }
}
</script>